/**
 * Sticky section headings (snippets/section-heading.liquid with `sticky: true`).
 *
 * CSS does the pinning (position: sticky). This marks the row while it's pinned (for
 * the shadow) and, when a tab is picked while pinned, scrolls back to the top of the
 * section's products so the new tab starts from its first row.
 */

const SELECTOR = '[data-sticky-heading]';

class StickyHeading {
  constructor(element) {
    this.element = element;
    this.container = element.parentElement;
    this.isStuck = false;
    element.addEventListener('click', (event) => {
      if (this.isStuck && event.target.closest('[role="tab"]')) this.scrollToTop();
    });
  }

  stickyTop() {
    return parseFloat(getComputedStyle(this.element).top) || 0;
  }

  update() {
    const top = this.stickyTop();
    const rect = this.element.getBoundingClientRect();
    const containerBottom = this.container.getBoundingClientRect().bottom;
    const shouldStick = rect.top <= top + 1 && containerBottom > top + rect.height;
    if (shouldStick !== this.isStuck) this.setStuck(shouldStick);
  }

  setStuck(stuck) {
    this.element.classList.toggle('is-stuck', stuck);
    this.isStuck = stuck;
  }

  // Back to where the heading first pins, so the new tab's products start below it.
  scrollToTop() {
    const target = this.container.getBoundingClientRect().top + window.scrollY - this.stickyTop();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: target, behavior: reduceMotion ? 'auto' : 'smooth' });
  }
}

const headings = new Map();
let frameQueued = false;

function updateAll() {
  frameQueued = false;
  headings.forEach((heading) => heading.update());
}

function queueUpdate() {
  if (frameQueued) return;
  frameQueued = true;
  requestAnimationFrame(updateAll);
}

function scan() {
  document.querySelectorAll(SELECTOR).forEach((element) => {
    if (!headings.has(element)) headings.set(element, new StickyHeading(element));
  });
  headings.forEach((_, element) => {
    if (!element.isConnected) headings.delete(element);
  });
  queueUpdate();
}

if (!window.__tssStickyHeadingBound) {
  window.__tssStickyHeadingBound = true;
  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', queueUpdate);
  document.addEventListener('shopify:section:load', scan);
}
scan();
